import { render, staticRenderFns } from "./MobileApp.vue?vue&type=template&id=1bbcf4f4&scoped=true"
import script from "./MobileApp.vue?vue&type=script&lang=js"
export * from "./MobileApp.vue?vue&type=script&lang=js"
import style0 from "./MobileApp.vue?vue&type=style&index=0&id=1bbcf4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbcf4f4",
  null
  
)

export default component.exports